import { useDispatch } from 'react-redux';
import { hasPermission, Permissions } from '../../../../../../store/reducers/user';
import { useMemo } from 'react';

const useSchedulerPermissions = () => {
    const dispatch = useDispatch();

    const canBookSlot = useMemo(() => dispatch(hasPermission(Permissions.AGYLE_CAN_BOOK_SCHEDULER)), [dispatch]);
    const canManageSlot = useMemo(() => dispatch(hasPermission(Permissions.AGYLE_CAN_MANAGE_SLOTS_SCHEDULER)), [dispatch]);
    const canManageSessions = useMemo(() => dispatch(hasPermission(Permissions.AGYLE_CAN_MANAGE_SESSIONS_SCHEDULER)), [dispatch]);
    const canAccessScheduler = useMemo(() => dispatch(hasPermission(Permissions.AGYLE_CAN_ACCESS_SCHEDULER)), [dispatch]);

    return {
        canBookSlot,
        canManageSlot,
        canManageSessions,
        canAccessScheduler,
    };
}

export default useSchedulerPermissions;